import { evaluate } from "mathjs";

export const checkCondition = (condition, inputsData) => {
  if (!condition) return true;
  if (condition.includes("&&") || condition.includes("||")) {
    return checkComplexCondition(condition, inputsData);
  } else {
    return checkSimpleCondition(condition, inputsData);
  }
};

const checkComplexCondition = (condition, inputsData) => {
  try {
    const listOfConditions = ["&&", "||"];
    const complexConditions = condition
      .match(new RegExp(`(.+?)(${listOfConditions.join("|")})(.+)`))[0]
      .split(/(\s+&&\s+|\s+\|\|\s+)/);
    let i = 0;
    let result = checkSimpleCondition(complexConditions[i], inputsData);
    for (i = 1; i < complexConditions.length; i += 2) {
      const operator = complexConditions[i].trim();
      const nextCondition = complexConditions[i + 1];
      const conditionResult = checkSimpleCondition(nextCondition, inputsData);
      //if the operator is AND
      if (operator === "&&") {
        result = result && conditionResult;
      } else {
        //if the operator is OR
        result = result || conditionResult;
      }
    }
    return result;
  } catch (error) {
    console.error("Error in condition: ", condition);
    return false;
  }
};

const checkSimpleCondition = (condition, inputsData) => {
  try {
    const listOfOperators = ["contains", "==", "!=", ">=", "<=", ">", "<"];
    const operatorRegex = listOfOperators
      .map((op) =>
        /^[a-z]+$/i.test(op) ? `\\b${op}\\b` : op.replace(/([=!<>])/g, "\\$1")
      )
      .join("|");
    const match = condition.match(
      new RegExp(`(.+?)\\s*(${operatorRegex})\\s*(.+)`, "i")
    );

    if (!match) throw new Error("Invalid condition format");

    let [, leftExpr, operator, rightExpr] = match;
    operator = operator.toLowerCase();

    // mathjs scope with inputs
    const scope = { ...inputsData };

    const evalWithFallback = (expr) => {
      expr = expr.trim();

      // If it's a quoted string (e.g. "active"), return string value
      if (
        (expr.startsWith('"') && expr.endsWith('"')) ||
        (expr.startsWith("'") && expr.endsWith("'"))
      ) {
        return expr.slice(1, -1);
      }

      // Try to evaluate as a math expression or input key
      try {
        const result = evaluate(expr, scope);
        return result;
      } catch {
        // If mathjs fails, treat as empty string
        return "";
      }
    };

    const leftValue = evalWithFallback(leftExpr);
    const rightValue = evalWithFallback(rightExpr);

    if (operator === "contains") {
      const toComparable = (value) => {
        if (value === null || value === undefined) return "";
        return String(value).trim().toLowerCase();
      };
      const needle = toComparable(rightValue);
      if (Array.isArray(leftValue)) {
        return leftValue.some((item) => toComparable(item) === needle);
      }
      return toComparable(leftValue).includes(needle);
    }

    switch (operator) {
      case "==":
        return leftValue == rightValue;
      case "!=":
        return leftValue != rightValue;
      case ">":
        return leftValue > rightValue;
      case "<":
        return leftValue < rightValue;
      case ">=":
        return leftValue >= rightValue;
      case "<=":
        return leftValue <= rightValue;
      default:
        return false;
    }
  } catch (error) {
    console.error("Error in condition: ", condition, error.message);
    return false;
  }
};
